import { PriceGroupType } from "shared/types/Price"
import { PriceGroup } from "shared/types/__generated__/graphql"

function comparePriceGroups(group1: PriceGroup, group2: PriceGroup) {
  if (
    group1.groupType === PriceGroupType.ORIGINAL &&
    group2.groupType === PriceGroupType.ORIGINAL
  ) {
    return group1.name > group2.name ? 1 : -1
  }
  if (
    group1.groupType === PriceGroupType.SPECIAL &&
    group2.groupType === PriceGroupType.SPECIAL
  ) {
    if (group1.parentPriceGroup !== group2.parentPriceGroup) {
      return group1.parentPriceGroup > group2.parentPriceGroup ? 1 : -1
    }
    return group1.name > group2.name ? 1 : -1
  }

  if (group1.parentPriceGroup === group2.parentPriceGroup) {
    return group1.groupType === PriceGroupType.ORIGINAL ? -1 : 1
  }

  return group1.parentPriceGroup > group2.parentPriceGroup ? 1 : -1
}

export function sortPriceGroups(groups: PriceGroup[]) {
  return [...groups].sort(comparePriceGroups)
}
